import styled from 'styled-components';
import { Theme } from '@/styles/theme';
import StyledText, { Props as StyledTextProps } from './StyledText';

export interface Props extends StyledTextProps {
  $bg?: keyof Theme['bg'];
}

const Root = styled(StyledText)<Props>`
  position: relative;
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 8px;
    ${({ $bg, theme }) => theme.bg[$bg ?? 'stroke']}
  }
`;

export default function Underline({
  ...props
}: Props & React.PropsWithChildren) {
  return <Root $fontSize="xxxl" $fontWeight="bold" {...props} />;
}
